
import { defineComponent } from 'vue'
import { EpbBadge } from '../shared/epb-badge'
import { EpbSwitch } from '../shared/epb-switch'

export default defineComponent({
  name: 'EnabledField',
  components: {
    EpbBadge,
    EpbSwitch,
  },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    info: String,
    disabled: Boolean,
    messages: {
      type: Object,
      required: true,
    },
  },
  computed: {
    label(): string {
      return this.value ? this.messages.states.enabled : this.messages.states.disabled
    },
  },
})
